import React, { useState } from "react";
import "./Login_signup.css";
import { Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Light_Black_Btn from "../../common_btn/light_black_btn/Light_Black_Btn";
import Successfull_Modal from "../common-modal/successfull_modal/Successfull_Modal";
import { SetPassword } from "../../../../features/admin/auth/Slice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Set_New_Password_Modal = ({ email, contact, ...props }) => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const {
    control, reset, setError,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };


  const onSubmit = async (d) => {
    if (!email && !contact) return;

    const data = {
      password: d.password,
    };

    if (email) data.email = email;
    if (contact) data.contact_no = contact;



    const verify = await dispatch(SetPassword(data));

    if (verify.meta?.requestStatus === "fulfilled") {
      props?.onHide();
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        reset()
      }, 3000);
    } else if (verify.meta?.requestStatus === "rejected") {
      setError("password", { type: "custom", message: verify.payload?.errors });
    }
  };

  return (
    <>
      <Modal
        className="Set_New_Password_Modal Reset_Password_Modal Login_Modal"
        size="md"
        {...props}
        centered
      >
        <div className="absolute_div">
          <div className="logo_holder">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
              className="logo_img"
            />
          </div>
        </div>
        <Modal.Body>
          <div className="reset_pass_main_form">
            <div className="close_img_div">
              <div className="title_div">
                <p className="title">Set New Password</p>
                <p className="sub_text">
                  Secure your account with a new password
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/assets/images/icons/close.png"}
                className="close_img"
                onClick={() => {
                  props?.onHide();
                }}
              />
            </div>

            <div className="reset_pass_div login_div">
              <div className="login_form_div">
                <Form>
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label className="label_text">
                      Enter new Password
                    </Form.Label>
                    <div className="password_holder">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Enter password"
                        {...register("password", {
                          required: "Password is required",
                          minLength: {
                            value: 8,
                            message:
                              "Password must be at least 8 characters long",
                          },
                          pattern: {
                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                            message:
                              "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                          },
                        })}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {errors?.password && (
                        <sup className="text-danger">
                          {errors?.password?.message}
                        </sup>
                      )}
                      <div className="eye-icc">
                        <FontAwesomeIcon
                          icon={iconOne}
                          className="icon"
                          onClick={() => togglePasswordVisibility("password")}
                        />
                      </div>
                    </div>
                  </Form.Group>

                  <Form.Group className="gray_input_group input_group">
                    <Form.Label className="label_text">
                      Enter your Confirm Password
                    </Form.Label>
                    <div className="password_holder">
                      <Form.Control
                        type={showPasswordOne ? "text" : "password"}
                        name="re_password"
                        placeholder="Confirm Password"
                        {...register("re_password", {
                          required: "Re-Enter Password  is required",
                        })}
                        onChange={(e) => setPasswordAgain(e.target.value)}
                      />

                      <div className="eye-icc">
                        <FontAwesomeIcon
                          icon={iconTwo}
                          className="icon"
                          onClick={() =>
                            togglePasswordVisibility("reenterPassword")
                          }
                        />
                      </div>
                      {errors?.re_password && (
                        <sup className="text-danger">
                          {errors?.re_password?.message}
                        </sup>
                      )}
                    </div>
                  </Form.Group>

                  {password && (
                    <div className="password_check_list">
                      <PasswordChecklist
                        rules={[
                          "minLength",
                          "specialChar",
                          "number",
                          "capital",
                          "match",
                        ]}
                        minLength={8}
                        value={password}
                        valueAgain={passwordAgain}
                        onChange={(isValid) => { }}
                        style={{
                          fontSize: "10px",
                          padding: "4px",
                          margin: "0",
                        }}
                      />
                    </div>
                  )}
                </Form>
              </div>

              <div className="btns_holder">
                <Light_Black_Btn
                  btnText={"Reset Password"}
                  onClick={handleSubmit(onSubmit)}
                // onClick={() => {
                //   props?.onHide();
                //   setShowSucsessModal(true);
                //   setTimeout(() => {
                //     setShowSucsessModal(false);
                //   }, 3000);
                // }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Successfull_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        headtext={"Password Updated"}
        successfultext={"Password Updated Successfully!"}
        subtext={"See You Soon!"}
        subtext2={"Have a nice time ahead"}
      />
    </>
  );
};

export default Set_New_Password_Modal;
